<app-header></app-header>
<ng-container *ngIf="accessApproval == true">
    <section class="content-box">
        <div class="tab-content" id="myTabContent">
            <!--  market Position -->
            <div class="tab-pane fade show active" id="market">
                <div class="deta-tebal-box">
                    <div class="setin-boxs d-flex justify-content-end">
                        <select class="form-control w-25 col-w defot-secot-box mr-3" name="badlaType" [(ngModel)]="selectedBadlaType" (change)="badlaTypeChnage($event.target.value)">
                            <option *ngFor="let category of instrumentCategory; let i = index;" value="{{category.name}}">{{category.name}}</option>
                        </select>

                        <select class="form-control w-25 col-w defot-secot-box" name="badlaType" [(ngModel)]="selectedScript">
                            <option [ngValue]="null">Select Badla</option>
                            <option *ngFor="let badlaIns of allScript; let i = index;" value="{{badlaIns._id}}">{{badlaIns.settingName}}</option>
                        </select>
                        <button type="button" class="btn but-boxa btn-primary" (click)="addBadlaScript()">
                            Add
                        </button>
                        <a class="btn but-boxa btn-warning " [routerLink]="['/history']">
                            Badla History  
                        </a>
                    </div>
                    <div class="respo-scroll" *ngIf="marketType=='market'">
                        <table class="default-table-style">
                            <thead>
                                <tr >
                                    <th class="text-left">Exchanges Name</th>
                                    <th class="text-left">Instrument Name</th>
                                    <th class="text-left">Buy Price</th>
                                    <th class="text-left">Sell Price</th>
                                    <th class="text-left">Net Change</th>
                                    <th class="text-left">High</th>
                                    <th class="text-left">Low</th>                                    
                                </tr>
                            </thead>
                            <tbody>
                                <!-- *ngFor="let img of bannerImages; let i = index;" -->
                                <ng-container *ngIf="badlaRecord.length > 0">
                                    <tr *ngFor="let brec of badlaRecord; let i = index;">
                                        <td class="text-left">{{brec.exchange}}</td>
                                        <td class="text-left">{{brec.name}} ({{brec.expiry}})</td>
                                        <td class="text-left buy" id="{{brec.instrument_token}}_buyprice">0</td>
                                        <td class="text-right buy" id="{{brec.instrument_token}}_sellprice">0</td>
                                        <td class="text-right buy" id="{{brec.instrument_token}}_net_change">0</td>
                                        <td class="text-right buy" id="{{brec.instrument_token}}_high">0</td>
                                        <td class="text-right buy" id="{{brec.instrument_token}}_low">0</td>
                                    </tr>    
                                </ng-container>
                                
                                <ng-container *ngIf="badlaRecord.length == 0">
                                    <tr>
                                        <td class="text-left" colspan="6">No record found</td>
                                    </tr>    
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                    <div class="respo-scroll" *ngIf="marketType=='livebadla'">
                        <table class="default-table-style">
                            <thead>
                                <tr >
                                    <th class="text-left" colspan="2">Symbol</th>
                                    <th class="text-center">Duty</th>
                                    <th class="text-center">Badla[BUY]</th>
                                    <th class="text-center">Badla[SELL]</th>
                                    <th class="text-center">Badla[LTP]</th>
                                    <!-- <th class="text-left">COMEX</th> -->
                                    <!-- <th class="text-left">MCX</th> -->
                                    <th class="text-center">
                                        <p>MCX BID</p>
                                        <p class="mcx-doller-rate">Comex (INR)</p>
                                    </th>
                                    <th class="text-center">
                                        <p>MCX ASK</p>
                                        <p class="mcx-doller-rate">Comex (INR)</p>
                                    </th>
                                    <th class="text-center">COMEX BID</th>
                                    <th class="text-center">COMEX ASK</th>
                                    <!-- <th class="text-left">DGCX</th> -->
                                    <th class="text-center">DGCX BID</th>
                                    <th class="text-center">DGCX ASK</th>
                                    <th class="text-center">DELETE</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngIf="badlaRecord.length == 0">
                                    <tr *ngFor="let binstu of badlaInstruments; let i = index;">
                                        <input type="hidden" id="{{binstu._id}}_prev_finalBadla">
                                        <td class="text-center m-0 p-0 " >
                                            <span (click)="openBadlaInfo(binstu)" class="fa fa-info icon-i-box" data-toggle="tooltip" data-placement="top" title="{{binstu.instrumentsDetail[0]['original_exchange']}}-{{binstu.instrumentsDetail[0]['expiry']}} {{binstu.instrumentsDetail[1]['original_exchange']}}-{{binstu.instrumentsDetail[1]['expiry']}} {{binstu.instrumentsDetail[2]['original_exchange']}}-{{binstu.instrumentsDetail[2]['expiry']}} Duty : {{binstu.settingValue[0]['Duty']}}"></span>
                                            <span (click)="openbadlaAddModal(binstu)" class="fa fa-plus icon-i-box ml-2"></span>
                                        </td>
                                        <td class="text-left">
                                            {{binstu.settingName}}
                                         </td>
                                        <td class="text-center"><span>{{binstu.settingValue[0]['Duty']}}</span></td>
                                        <td class="text-center" id="sell_{{binstu._id}}"></td>
                                        <td class="text-center" id="buy_{{binstu._id}}"></td>
                                        <td class="text-center" id="{{binstu._id}}"></td>
                                        <!-- <td class="text-left">{{binstu.instrumentsDetail[0].expiry}}</td> -->
                                        <td class="text-center" id="{{binstu.instrumentsDetail[0].instrument_token}}_{{binstu._id}}_badla_buyP_bg">
                                            <p id="{{binstu.instrumentsDetail[0].instrument_token}}_{{binstu._id}}_badla_buyP">0</p>
                                            <p id="{{binstu.instrumentsDetail[0].instrument_token}}_{{binstu._id}}_badla_dollerBuy" class="mcx-doller-rate">0</p>
                                        </td>
                                        <td class="text-center" id="{{binstu.instrumentsDetail[0].instrument_token}}_{{binstu._id}}_badla_sellP_bg">
                                            <p id="{{binstu.instrumentsDetail[0].instrument_token}}_{{binstu._id}}_badla_sellP">0</p>
                                            <p id="{{binstu.instrumentsDetail[0].instrument_token}}_{{binstu._id}}_badla_dollerSell" class="mcx-doller-rate">0</p>
                                        </td>
                                        <!-- <td class="text-left">{{binstu.instrumentsDetail[1].expiry}}</td> -->
                                        <td class="text-center" id="{{binstu.instrumentsDetail[1].instrument_token}}_{{binstu._id}}_badla_buyP_bg"><span id="{{binstu.instrumentsDetail[1].instrument_token}}_{{binstu._id}}_badla_buyP">0</span> </td>
                                        <td class="text-center" id="{{binstu.instrumentsDetail[1].instrument_token}}_{{binstu._id}}_badla_sellP_bg"><span id="{{binstu.instrumentsDetail[1].instrument_token}}_{{binstu._id}}_badla_sellP">0</span></td>
                                        <!-- <td class="text-left">{{binstu.instrumentsDetail[2].expiry}}</td> -->
                                        <td class="text-center" id="{{binstu.instrumentsDetail[2].instrument_token}}_{{binstu._id}}_badla_buyP_bg">
                                            <p id="{{binstu.instrumentsDetail[2].instrument_token}}_{{binstu._id}}_badla_buyP">0</p>
                                            <p id="{{binstu.instrumentsDetail[2].instrument_token}}_{{binstu._id}}_badla_dollerPBuy" class="mcx-doller-rate">0</p>
                                        </td>
                                        <td class="text-center" id="{{binstu.instrumentsDetail[2].instrument_token}}_{{binstu._id}}_badla_sellP_bg">
                                            <p id="{{binstu.instrumentsDetail[2].instrument_token}}_{{binstu._id}}_badla_sellP">0</p>
                                            <p id="{{binstu.instrumentsDetail[2].instrument_token}}_{{binstu._id}}_badla_dollerPSell" class="mcx-doller-rate">0</p>
                                        </td>
                                        <td class="text-center">
                                            <span class="fa fa-trash" (click)="deleteUserScript(binstu._id)" data-toggle="tooltip" data-placement="top"></span>
                                        </td>
                                        
                                        <input type="hidden" id="{{binstu.instrumentsDetail[0].instrument_token}}_{{binstu._id}}_prev_buy_comex">
                                        <input type="hidden" id="{{binstu.instrumentsDetail[0].instrument_token}}_{{binstu._id}}_prev_sell_comex">
                                        <input type="hidden" id="{{binstu.instrumentsDetail[1].instrument_token}}_{{binstu._id}}_prev_buy_mcx">
                                        <input type="hidden" id="{{binstu.instrumentsDetail[1].instrument_token}}_{{binstu._id}}_prev_sell_mcx">
                                        <input type="hidden" id="{{binstu.instrumentsDetail[2].instrument_token}}_{{binstu._id}}_prev_buy_dgcx">
                                        <input type="hidden" id="{{binstu.instrumentsDetail[2].instrument_token}}_{{binstu._id}}_prev_sell_dgcx">
    
                                     </tr>         
                                </ng-container>
                                 <ng-container *ngIf="badlaInstruments.length == 0">
                                    <tr>
                                        <td class="text-center m-0 p-0 " colspan="12">No record found</td>
                                    </tr>    
                                </ng-container>  
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
            <!-- badle settig -->
            <div class="tab-pane fade" id="badle">
               1 
            </div>
            <!--  settig Report -->
            <div class="tab-pane fade" id="settig">
                2
            </div>
            <!-- porfile Summary -->
            <div class="tab-pane fade" id="porfile">
              3 
            </div>


        </div>
       
    </section>
    <app-footer></app-footer>
</ng-container>
<ng-container *ngIf="accessApproval == false">
    <div class="alert alert-danger" role="alert">
        You can not access this panel.
      </div>
</ng-container>

<div class="modal fade" bsModal #badlaInfoModal="bs-modal" [config]="{}" id="exampleModalCenter" tabindex="-1"
    role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h6 class="modal-title" id="exampleModalLongTitle"><span>Instrument Information</span></h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="closeBadlaOrder()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <table class="default-table-style">
                    <!-- <thead>
                        <tr>
                            <td>Make</td>
                        </tr>
                    </thead> -->
                    <tbody *ngIf="badlaInfo">
                        <tr>
                            <td colspan="2">
                                {{badlaInfo.instrumentsDetail[0]['original_exchange']}}-{{badlaInfo.instrumentsDetail[0]['expiry']}}
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                {{badlaInfo.instrumentsDetail[1]['original_exchange']}}-{{badlaInfo.instrumentsDetail[1]['expiry']}}
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                {{badlaInfo.instrumentsDetail[2]['original_exchange']}}-{{badlaInfo.instrumentsDetail[2]['expiry']}}
                            </td>
                        </tr>
                        <tr>
                            <td><label for="dutyInput">Duty:</label></td>
                            <td><input type="text" id="dutyInput" class="form-control ng-pristine ng-valid ng-touched"
                                    placeholder="Enter Duty" [(ngModel)]="badlaInfo.settingValue[0]['Duty']"></td>
                        </tr>
                        <tr>
                            <td><label for="differenceInput">Difference value:</label>
                            </td>
                            <td><input type="text" id="differenceInput" class="form-control"
                                    placeholder="Difference value" [(ngModel)]="diffrenceRate"> </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" (click)="closeBadlaOrder()">Close</button>
                <button type="button" class="btn btn-success"
                    (click)="diffrenceRateSubmit(badlaInfo['_id'], diffrenceRate !== null ? diffrenceRate : 0 , badlaInfo.settingValue[0]['Duty'])">Submit</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" bsModal #orderModal="bs-modal" [config]="{}" id="exampleModalCenter" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg " role="document">
        <div class="modal-content ">
            <div class="modal-header">
                <h6 class="modal-title" id="exampleModalLongTitle"> <span *ngIf="!filter.id && endOrder==false">Add
                        badla order</span> <span *ngIf="filter.id && endOrder==false">Update badla order</span> <span
                        *ngIf="endOrder==true">End badla order</span></h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
                    <span aria-hidden="true">&times;</span>
                </button>

            </div>
            <div class="modal-body p-0 m-2">
                <form #addBadlaOrder="ngForm" (ngSubmit)="(addBadlaOrder.form.valid  && createBadlaOrder())">
                    <div class="form-group row">
                        <div class=" col-lg-4 col-sm-6 col-6 input-box-grup">
                            <label for="inputPassword" class=" col-form-label">Reference Name</label>
                            <input type="text" class="form-control" placeholder="Reference Name"
                                [(ngModel)]="filter.reference" name="referenceName" #referenceName="ngModel" required
                                pattern="^[A-Za-z0-9._ -]*$" maxlength="50" [disabled]="endOrder==true">
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="referenceName.errors?.required" class="invalid-error">
                                    Enter Reference.
                                </div>
                                <div *ngIf="referenceName.errors?.pattern" class="invalid-error">
                                    Enter Valid Reference.
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6 col-6 input-box-grup" *ngIf="!filter.id && endOrder==false">
                            <label for="inputPassword" class="col-form-label ">Select Badla Type</label>
                            <select class="form-control" name="badlaType" #badlaType="ngModel" [(ngModel)]="selectedBadlaTypeFrm">
                                <option *ngFor="let category of instrumentCategory; let i = index;" value="{{category.name}}">{{category.name}}</option>                          
                            </select>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="badlaType.errors?.required" class="invalid-error">
                                    Please Select Badla Type.
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2 col-sm-3 col-6 input-box-grup main-chek " >
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                                    [(ngModel)]="isBrokrageCheck" name="brokrageCheckBox" #brokrageCheckBox="ngModel"
                                    (change)="checkBrokrage(isBrokrageCheck?true:false)" *ngIf="endOrder == false">
                                <label class="form-check-label" for="flexCheckDefault">
                                    Add Brokerage
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-lg-4 col-sm-6 col-6 input-box-grup">
                            <label for="inputPassword" class="col-form-label ">Badla Instrument</label>
                            <select class="form-control" [(ngModel)]="filter.type" name="badlaTypeInstrument" #badlaTypeInstrument="ngModel"
                                required [disabled]="endOrder==true" (change)="badlaScriptChnage($event.target.value)">
                                <option [ngValue]="null" *ngIf="!filter.id && endOrder==false">Select Badla</option>
                                <option *ngFor="let title of badlaInstrument" [value]="title._id">
                                    {{title.settingName}}
                                </option>
                            </select>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="badlaTypeInstrument.errors?.required" class="invalid-error">
                                    Please Select Badla Type.
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-6 input-box-grup">
                            <label for="inputPassword" class="col-sm-2 col-form-label">Duty</label>
                            <input type="text" class="form-control" placeholder="Duty" [(ngModel)]="filter.duty"
                                name="dutyName" #dutyName="ngModel" required pattern="^[0-9._-]*$" maxlength="10"
                                [disabled]="endOrder==true">
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="dutyName.errors?.required" class="invalid-error">
                                    Enter Duty.
                                </div>
                                <div *ngIf="dutyName.errors?.pattern" class="invalid-error">
                                    Enter Valid Duty.
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6 col-6 input-box-grup"  *ngIf="!filter.id && endOrder==false">
                            <label for="inputPassword" >Opening Amount(Optional)</label>
                            <input type="text" class="form-control" placeholder="Opening Amount" [(ngModel)]="filter.openingAmount"
                                name="openingAmount" #openingAmount="ngModel" pattern="^[0-9._-]*$" maxlength="10"
                                [disabled]="endOrder==true">
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="openingAmount.errors?.pattern" class="invalid-error">
                                    Enter Valid Opening Amount.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="inputPassword" class="col-form-label">COMEX Instrument</label>
                            <select class="form-control" [(ngModel)]="filter.comexbadlaInst" name="comexInstName"
                                #comexInstName="ngModel" (change)="chnageInsrument($event.target.value,'comexRateId')" required [disabled]="endOrder==true">
                                <option [ngValue]="null">Select Instrument</option>
                                <option *ngFor="let badla of comexBadlaInstrument" [value]="badla.instrument_token">
                                    {{badla.exchange}} - {{badla.name}} - {{badla.expiry}}
                                </option>
                            </select>
                            <div id="comexRateId"></div>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="comexInstName.errors?.required" class="invalid-error">
                                    Please Select COMEX Instrument.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Type" class="col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.comexType" name="comexTypeName"
                                #comexTypeName="ngModel" required (change)="comexTypeChnage()"
                                [disabled]="endOrder==true">
                                <option [ngValue]="null">Type</option>
                                <option value="buy">Buy</option>
                                <option value="sell">Sell</option>
                            </select>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="comexTypeName.errors?.required" class="invalid-error">
                                    Please Select Type.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Qty" class="col-form-label">Qty</label>
                            <input type="text" class="form-control" placeholder="Qty" [(ngModel)]="filter.comexQty"
                                name="comexQtyeName" #comexQtyeName="ngModel" required pattern="^[0-9._-]*$"
                                maxlength="5" [disabled]="endOrder==true">
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="comexQtyeName.errors?.required" class="invalid-error">
                                    Enter Qty.
                                </div>
                                <div *ngIf="comexQtyeName.errors?.pattern" class="invalid-error">
                                    Enter Valid Qty.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Price" class="col-form-label">Price</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.comexPrice" placeholder="Price"
                                name="comexPriceName" #comexPriceName="ngModel" required pattern="^[0-9.]*$"
                                maxlength="10">
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="comexPriceName.errors?.required" class="invalid-error">
                                    Enter Price.
                                </div>
                                <div *ngIf="comexPriceName.errors?.pattern" class="invalid-error">
                                    Enter Valid Price.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageCheck">
                            <label for="Type" class="col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.comexBroType" name="comexBrokrageType"
                                #comexBrokrageType="ngModel">
                                <option [ngValue]="null">Brokrage Type</option>
                                <option value="lot">Lotwise</option>
                                <!-- <option value="sell">Percentage</option> -->
                            </select>
                            <!-- <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="comexBrokrageType.errors?.required" class="invalid-error">
                                    Please Select Type.
                                </div>
                            </div> -->
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageCheck">
                            <label for="Brokerage Amount" class="col-form-label">Brokerage Amount</label>
                            <input type="text" class="form-control" placeholder="Brokerage Amount"
                                [(ngModel)]="filter.comexBroAmount" name="comexBrokrageAmount"
                                #comexBrokrageAmount="ngModel" pattern="^[0-9._-]*$" maxlength="5">
                            <div *ngIf="addBadlaOrder.submitted">
                                <!-- <div *ngIf="comexBrokrageAmount.errors?.required" class="invalid-error">
                                    Enter Amount.
                                </div> -->
                                <div *ngIf="comexBrokrageAmount.errors?.pattern" class="invalid-error">
                                    Enter Valid Amount.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="MCX Instrument" class="col-form-label">MCX Instrument</label>
                            <select class="form-control" [(ngModel)]="filter.mcxbadlaInst" name="mcxInstName" (change)="chnageInsrument($event.target.value,'mcxRateId')" 
                                #mcxInstName="ngModel" required [disabled]="endOrder==true">
                                <option [ngValue]="null">Select Instrument</option>
                                <option *ngFor="let badla of mcxBadlaInstrument" [value]="badla.instrument_token">
                                    {{badla.exchange}} - {{badla.name}} - {{badla.expiry}}
                                </option>
                            </select>
                            <div id="mcxRateId"></div>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="mcxInstName.errors?.required" class="invalid-error">
                                    Please Select MCX Instrument.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Type" class="col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.mcxType" name="mcxTypeName"
                                #mcxTypeName="ngModel" required disabled='true'>
                                <option [ngValue]="null">Type</option>
                                <option value="buy">Buy</option>
                                <option value="sell">Sell</option>
                            </select>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="mcxTypeName.errors?.required" class="invalid-error">
                                    Please Select Type.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Qty" class="col-form-label">Qty</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.mcxQty" placeholder="Qty"
                                name="mcxQtyeName" #mcxQtyeName="ngModel" required pattern="^[0-9.]*$"
                                [disabled]="endOrder==true">
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="mcxQtyeName.errors?.required" class="invalid-error">
                                    Enter Qty.
                                </div>
                                <div *ngIf="mcxQtyeName.errors?.pattern" class="invalid-error">
                                    Enter Valid Qty.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Price" class="col-form-label">Price</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.mcxPrice" placeholder="Price"
                                name="mcxPriceName" #mcxPriceName="ngModel" pattern="^[0-9_.-]*$" required>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="mcxPriceName.errors?.required" class="invalid-error">
                                    Enter Price.
                                </div>
                                <div *ngIf="mcxPriceName.errors?.pattern" class="invalid-error">
                                    Enter Valid Qty.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageCheck">
                            <label for="Type" class="col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.mcxBroType" name="mcxBrokrageType"
                                #mcxBrokrageType="ngModel">
                                <option [ngValue]="null">Brokrage Type</option>
                                <option value="lot">Lotwise</option>
                                <option value="per">Turnoverwise % | Lakh</option>
                            </select>
                            <!-- <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="mcxBrokrageType.errors?.required" class="invalid-error">
                                    Please Select Type.
                                </div>
                            </div> -->
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageCheck">
                            <label for="Brokerage Amount" class="col-form-label">Brokerage Amount</label>
                            <input type="text" class="form-control" placeholder="Brokerage Amount"
                                [(ngModel)]="filter.mcxBroAmount" name="mcxBrokrageAmount" #mcxBrokrageAmount="ngModel"
                                 pattern="^[0-9._-]*$" maxlength="5">
                            <div *ngIf="addBadlaOrder.submitted">
                                <!-- <div *ngIf="mcxBrokrageAmount.errors?.required" class="invalid-error">
                                    Enter Amount.
                                </div> -->
                                <div *ngIf="mcxBrokrageAmount.errors?.pattern" class="invalid-error">
                                    Enter Valid Amount.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="inputPassword" class=" col-form-label">DGCX Instrument</label>
                            <select class="form-control" [(ngModel)]="filter.dgcxbadlaInst" name="dgcxInstName" (change)="chnageInsrument($event.target.value,'dgcxRateId')"
                                #dgcxInstName="ngModel" required [disabled]="endOrder==true">
                                <option [ngValue]="null">Select Instrument</option>
                                <option *ngFor="let badla of dgcxBadlaInstrument" [value]="badla.instrument_token">
                                    {{badla.exchange}} - {{badla.name}} - {{badla.expiry}}
                                </option>
                            </select>
                            <div id="dgcxRateId"></div>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="dgcxInstName.errors?.required" class="invalid-error">
                                    Please Select DGCX Instrument.
                                </div>
                            </div>
                        </div>
                     
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Type" class=" col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.dgcxType" name="dgcxTypeName"
                                #dgcxTypeName="ngModel" required disabled='true'>
                                <option [ngValue]="null">Type</option>
                                <option value="buy">Buy</option>
                                <option value="sell">Sell</option>
                            </select>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="dgcxTypeName.errors?.required" class="invalid-error">
                                    Please Select Type.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Qty" class=" col-form-label">Qty</label>
                            <input type="text" class="form-control" placeholder="Qty" [(ngModel)]="filter.dgcxQty"
                                name="dgcxQtyeName" #dgcxQtyeName="ngModel" required pattern="^[0-9.]*$"
                                [disabled]="endOrder==true">
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="dgcxQtyeName.errors?.required" class="invalid-error">
                                    Enter Qty.
                                </div>
                                <div *ngIf="dgcxQtyeName.errors?.pattern" class="invalid-error">
                                    Enter Valid Qty.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}">
                            <label for="Price" class=" col-form-label">Price</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.dgcxPrice" placeholder="Price"
                                name="dgcxPriceName" #dgcxPriceName="ngModel" required pattern="^[0-9_.-]*$">
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="dgcxPriceName.errors?.required" class="invalid-error">
                                    Enter Price.
                                </div>
                                <div *ngIf="dgcxPriceName.errors?.pattern" class="invalid-error">
                                    Enter Valid Price.
                                </div>
                            </div>
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageCheck">
                            <label for="inputPassword" class=" col-form-label">Type</label>
                            <select class="form-control" [(ngModel)]="filter.dgcxBroType" name="dgcxBrokrageType"
                                #dgcxBrokrageType="ngModel">
                                <option [ngValue]="null">Brokrage Type</option>
                                <option value="lot">Lotwise</option>
                                <!-- <option value="sell">Percentage</option> -->
                            </select>
                            <!-- <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="dgcxBrokrageType.errors?.required" class="invalid-error">
                                    Please Select Type.
                                </div>
                            </div> -->
                        </div>
                        <div class="{{isBrokrageCheck == true ? 'col-lg-2 col-sm-6 col-6 input-box-grup' : 'col-lg-3 col-sm-6 col-6 input-box-grup' }}" *ngIf="isBrokrageCheck">
                            <label for="Brokerage Amount" class=" col-form-label">Brokerage Amount</label>
                            <input type="text" class="form-control" placeholder="Brokerage Amount"
                                [(ngModel)]="filter.dgcxBroAmount" name="dgcxBrokrageAmount"
                                #dgcxBrokrageAmount="ngModel" pattern="^[0-9._-]*$" maxlength="5">
                            <div *ngIf="addBadlaOrder.submitted"> 
                                <!-- <div *ngIf="dgcxBrokrageAmount.errors?.required" class="invalid-error">
                                    Enter Amount.
                                </div> -->
                                <div *ngIf="dgcxBrokrageAmount.errors?.pattern" class="invalid-error">
                                    Enter Valid Amount.
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="form-group row" *ngIf="endOrder==true">
                        <!-- <div class="col-lg-3 col-sm-6 col-6">
                            <input name="options" ng-control="options" type="radio" [value]="1" [(ngModel)]="filter.endandopen"> End Badla<br/>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-6">
                            <input name="options" ng-control="options" type="radio" [value]="2" [(ngModel)]="filter.endandopen"> End Badla & Open<br/>
                        </div> -->
                        <div class="col-lg-3 col-sm-6 col-6 input-box-grup">
                            <label for="Brokerage Amount" class=" col-form-label">Select End Badla Option</label>
                            <select class="form-control" [(ngModel)]="filter.endandopen" name="endBadlaType"
                                    #endBadlaType="ngModel" required  (change)="settlementTypeChnage($event.target.value)">
                                    <option [ngValue]="null">Type</option>
                                    <option value="1">End Badla</option>
                                    <!-- <option value="2">End Badla With Brokerage</option> -->
                                    <option value="2">Weekly Settlement</option>
                                    <option value="3">Weekly Settlement With Clearing Rate</option>
                            </select>
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="endBadlaType.errors?.required" class="invalid-error">
                                    Enter Badla Type.
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2 col-sm-3 col-6 input-box-grup main-chek " *ngIf="endOrder==true && settlementType == '1'">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                                    [(ngModel)]="isEndClosingRate" name="closdingCheckBox" #closdingCheckBox="ngModel"
                                    (change)="checkEndClosing(isEndClosingRate?true:false)">
                                <label class="form-check-label" for="flexCheckDefault">
                                    Add Closing Rate 
                                </label>
                            </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-6 input-box-grup" *ngIf="endOrder==true && (settlementType == '3') ">
                            <label for="Brokerage Amount" class=" col-form-label">Doller Closing Rate</label>
                            <input type="text" class="form-control" [(ngModel)]="closingRate" placeholder="Doller Closing"
                            name="closingRateAmt" #closingRateAmt="ngModel" required pattern="^[0-9_.-]*$">
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="closingRateAmt.errors?.required" class="invalid-error">
                                    Enter Doller Closing.
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-6 input-box-grup" *ngIf="endOrder==true && settlementType == '1' && isEndClosingRate== true ">
                            <label for="Brokerage Amount" class=" col-form-label">Doller Closing Rate</label>
                            <input type="text" class="form-control" [(ngModel)]="closingRate" placeholder="Doller Closing"
                            name="closingRateAmt" #closingRateAmt="ngModel" required pattern="^[0-9_.-]*$">
                            <div *ngIf="addBadlaOrder.submitted">
                                <div *ngIf="closingRateAmt.errors?.required" class="invalid-error">
                                    Enter Doller Closing.
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2 col-sm-3 col-6 input-box-grup main-chek " *ngIf="endOrder==true && settlementType == '1'">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                                    [(ngModel)]="isBrokrageCheckEnd" name="brokrageCheckBox" #brokrageCheckBox="ngModel"
                                    (change)="checkBrokrageEnd(isBrokrageCheckEnd?true:false)">
                                <label class="form-check-label" for="flexCheckDefault">
                                    Add Brokerage
                                </label>
                            </div>
                        </div>

                    </div>

                    <div class="row mt-2">
                        <div class="col-6 m-0 ">
                            <button type="button" class="btn btn-danger w-100" data-dismiss="modal"
                                (click)="closeModal()">Close</button>
                        </div>

                        <div class="col-6 m-0" >
                            <button type="submit" class="btn btn-success w-100">Submit</button>
                        </div>
                    </div>
                    <!--  -->
                </form>
            </div>
        </div>
    </div>
</div>